// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"8":"editor","140":"email_verified","419":"wiki","542":"overview","884":"admin"}[chunkId] || chunkId) + "." + {"8":"36d4757b","140":"4b338017","279":"2b008171","419":"179c4ecf","466":"6211b982","542":"fc9fc984","684":"79c13cc1","884":"4b9198ca"}[chunkId] + ".js";
};